import { fabric as c } from "fabric";
const i = /* @__PURE__ */ new Map(), b = async (t) => {
  const a = i.get(t);
  if (a) {
    const r = await a;
    return new Promise((e) => {
      r.clone((o) => {
        e(o);
      });
    });
  }
  const s = new Promise((r) => t.substring(0, 5) !== "https" ? c.loadSVGFromString(t, (e, o) => {
    const n = c.util.groupSVGElements(e, {
      ...o
    });
    r(n);
  }) : c.loadSVGFromURL(t, (e, o) => {
    const n = c.util.groupSVGElements(e, {
      ...o
    });
    r(n);
  }));
  return i.set(t, s), s;
};
export {
  b as createFabricImageFromSvgString
};
//# sourceMappingURL=index.es454.js.map
